import React from 'react';
// import logo from './logo.svg';
import './App.css';
import SearchMovie from './main/SearchMovie';

function App() {
  return (
    <div className="container">
        <h1 className ="title">Movies Cloud9</h1>
        <SearchMovie />
    </div>
  );
}

export default App;
